module.exports = __webpack_public_path__ + "static/media/rooftop.368e6899.jpg";